var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "confirmation"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("掛號成功")]), _c('div', {
    staticClass: "reminder-green",
    domProps: {
      "innerHTML": _vm._s(_vm.reminderMessage)
    }
  }), _c('div', {
    staticClass: "appointment-info"
  }, _vm._l(_vm.infoItems, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "info-label"
    }, [_vm._v(_vm._s(item.label))]), _c('span', {
      staticClass: "info-value",
      class: item.color
    }, [_vm._v(_vm._s(item.value))])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }